<template>
  <pre-survey-form :is-submitting-form="isSubmittingForm" :survey-id="surveyId" @submit="onSubmit" @automatic-submit="onAutomaticSubmit">
    <CloudflareTurnstileWidget theme="auto" @success="handleTurnstileSuccess" @expired="handleTurnstileTokenExpired" />
  </pre-survey-form>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import CloudflareTurnstileWidget from '@/modules/survey/views/components/CloudflareTurnstileWidget.vue'
import PreSurveyForm from '@/modules/survey/views/components/PreSurveyForm.vue'
import surveyEntryMixin from '@/modules/survey/mixins/survey-entry-mixin'
import FingerprintJS from '@fingerprintjs/fingerprintjs'

export default {
  name: 'SurveyIdEntry',
  components: {
    CloudflareTurnstileWidget,
    PreSurveyForm
  },
  mixins: [surveyEntryMixin],
  data: () => ({
    isSubmittingForm: false,
    cloudflareTurnstileToken: null,
    automaticSubmit: false
  }),
  computed: {
    ...mapGetters('survey', ['GET_SURVEY_USER_ID']),
    surveyUserId() {
      return this.GET_SURVEY_USER_ID
    },
    surveyId() {
      return this.$route.params.surveyId
    }
  },
  methods: {
    ...mapActions('survey', ['authenticateUserFromSurvey', 'setSurveyUserId']),

    onAutomaticSubmit() {
      this.automaticSubmit = true
    },
    async onSubmit() {
      this.isSubmittingForm = true
      if (this.cloudflareTurnstileToken === null) {
        this.$snackbar({
          message: 'Preencha a verificação de segurança.',
          snackbarColor: 'error'
        })
        return
      }

      try {
        if (!this.surveyUserId) {
          const fp = await FingerprintJS.load()
          const { visitorId } = await fp.get()
          this.setSurveyUserId(visitorId)
        }

        await this.authenticateUserFromSurvey({
          surveyId: this.surveyId,
          userId: this.surveyUserId,
          turnstileCode: this.cloudflareTurnstileToken
        })
        this.$router.push({ name: 'survey-form', params: { surveyId: this.surveyId } })
      } catch (error) {
        this.redirectToError(error)
      } finally {
        this.isSubmittingForm = false
      }
    },
    handleTurnstileSuccess(token) {
      this.cloudflareTurnstileToken = token
      if (this.automaticSubmit) {
        this.onSubmit()
      }
    },
    handleTurnstileTokenExpired() {
      this.cloudflareTurnstileToken = null
    }
  }
}
</script>
